import React from "react";
// import { Icon } from './';

export function Button(props) {
  const {
    type,
    color,
    onClick,
    size,
    icon,
    iconOnly,
    block,
    disabled,
    children,
    className,
    link,
    href,
    ...rest
  } = props;
  // console.log("REST", rest);
  let classes = className ? className + " chronos-btn" : "chronos-btn";
  if (color) {
    classes += ` chronos-btn-${color}`;
  }
  if (size) {
    classes += ` chronos-btn-${size}`;
  }
  if (block) {
    classes += ` chronos-btn-block`;
  }
  if (icon) {
    classes += ` chronos-icon-btn`;
  }
  if (iconOnly) {
    classes += ` chronos-icon-only-btn`;
  }

  if (disabled) {
    classes += ` chronos-btn-disabled`;
  }

  const handleLinkClick = (ev) => {
    if (onClick) {
      return onClick(ev);
    }
    return;
  };

  return (
    <React.Fragment>
      {link ? (
        <a
          href={href}
          target="_blank"
          className={classes}
          disabled={disabled}
          onClick={handleLinkClick}
          {...rest}
        >
          {children}
        </a>
      ) : (
        <button
          type={type ? type : "button"}
          className={classes}
          onClick={onClick}
          disabled={disabled}
          {...rest}
        >
          {children}
        </button>
      )}
    </React.Fragment>
  );
}
